import { useState } from "react";
import { DestinationUI } from "@/adapters/offerAdapter";

interface OfferCardProps {
  destination: DestinationUI;
  index: number;
}

const FALLBACK_IMAGES = [
  "https://s3.amazonaws.com/media.costamar.com/IMG-WEB/DEFAULT04.jpg",
  "https://s3.amazonaws.com/media.costamar.com/IMG-WEB/DEFAULT06.jpg",
];

const getRandomFallbackImage = () =>
  FALLBACK_IMAGES[Math.floor(Math.random() * FALLBACK_IMAGES.length)];

const OfferCard = ({ destination, index }: OfferCardProps) => {
  const [imgSrc, setImgSrc] = useState(destination.image);

  const handleImageError = () => {
    setImgSrc(getRandomFallbackImage());
  };

  return (
    <a
      href={destination.url}
      role="link"
      tabIndex={0}
      className="relative h-80 rounded-2xl overflow-hidden group cursor-pointer animate-fade-in position-relative"
      style={{ animationDelay: `${index * 0.1}s`, display: 'block' }}
    >
      <img
        src={imgSrc}
        alt={`Vista de ${destination.city}, ${destination.country}`}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        loading="lazy"
        onError={handleImageError}
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30" />

      {/* Header - TOP */}
      <div className="absolute top-4 left-4 right-4">
        <h3 className="text-2xl font-bold text-white drop-shadow-lg">
          {destination.city}
        </h3>
        <p className="text-sm text-white/80 font-medium drop-shadow">
          {destination.country}
        </p>
      </div>

      {/* Body - CENTER LEFT - Glassmorphism Price Card */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2">
        <div className="px-5 py-4 rounded-xl backdrop-blur-md border border-white/20 shadow-xl bg-secondary">
          <p className="text-xs text-white/90 font-medium">Desde</p>
          <p className="text-2xl font-bold text-white">
            ${destination.priceUSD.toFixed(2)}
          </p>
          <p className="text-xs text-white/90 font-medium uppercase tracking-wide">
            { destination.flightIndicator }
          </p>
        </div>
      </div>
    </a>
  );
};

export default OfferCard;
